<mat-form-field
  appearance="outline"
  class="w-full"
  [subscriptSizing]="subscriptSizing()">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    type="text"
    autocomplete="off"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    [errorStateMatcher]="errorStateMatcher"
    (blur)="onBlur()" />
  <mat-icon matSuffix class="text-neutral-40">arrow_drop_down</mat-icon>

  <mat-autocomplete
    #auto="matAutocomplete"
    autoActiveFirstOption
    [displayWith]="displayUser"
    (optionSelected)="onOptionSelected($event)"
    (closed)="onPanelClosed()">
    @for (user of filteredUsers; track user.userId) {
      <mat-option [value]="user">{{ user.user?.fullName }}</mat-option>
    }

    @if (filterNoResults) {
      <mat-option disabled i18n>No se encontraron resultados</mat-option>
    }
  </mat-autocomplete>

  @if (hasError) {
    <mat-error align="start">
      <qaroni-input-error-messages [fc]="control" />
    </mat-error>
  }
</mat-form-field>
